module.exports = __webpack_public_path__ + "img/805.26c35082.png";